import { LoadingButton } from '@mui/lab';
import { Box, Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Stack, Switch, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Axios from '../../axios/Axios';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../redux/features/appSlice';
import { setTemplate } from '../redux/features/templateSlice';
import axios from 'axios';

function SetMessageTemplates() {

  const dispatch = useDispatch();
  const { templates } = useSelector(data => data);
  const userId = sessionStorage.getItem("user_id");
  const selectMailTemplateDropdownArray = templates.filter(template => template.template_type === "mail"); 
  const selectWhatsappTemplateDropdownArray = templates.filter(template => template.template_type === "whatsapp"); 
  const [ editable, setEditable ] = useState(false);
  const [ isLoading, setLoading ] = useState(false);
  const [ templateType, setTemplateType ] = useState("mail");
  const [ mailType, setMailType ] = useState("teacher_callout_mail_template");
  const [ whatsappType, setWhatsappType ] = useState("teacher_callout_whatsapp_template");
  const [ subject, setSubject ] = useState("");
  const [ header, setHeader ] = useState("");
  const [ message, setMessage ] = useState("");
  const [ footer, setFooter ] = useState("");
  const [ whatsappMessage, setWhatsappMessage ] = useState("");
  const [ error, setError ] = useState({subjectError: false, headerError: false, footerError: false});
  const [ modifiedDetails, setModifiedDetails ] = useState({ modifiedBy: "", modifiedAt: ""});
  const [resetField , setResetField] = useState(false)
  console.log(mailType);
  

  useEffect(() => {
  if (templateType === "mail") {
    const tempTemplate = selectMailTemplateDropdownArray.find(
      (templateObj) => templateObj.mail_type === mailType
    );
    if (tempTemplate) {
      setSubject(tempTemplate.subject || "");
      setHeader(tempTemplate.header || "");
      setMessage(tempTemplate.message || "");
      setFooter(tempTemplate.footer || "");
      setModifiedDetails({
        modifiedBy: tempTemplate.username,
        modifiedAt: tempTemplate.updated_at,
      });
    }
  } else {
    const tempTemplate = selectWhatsappTemplateDropdownArray.find(
      (templateObj) => templateObj.mail_type === whatsappType
    );
    if (tempTemplate) {
      setWhatsappMessage(tempTemplate.message || "");
      setModifiedDetails({
        modifiedBy: tempTemplate.username,
        modifiedAt: tempTemplate.updated_at,
      });
    }
  }
}, [mailType, whatsappType, templateType]);

useEffect(() => {
  const controller = axios.CancelToken.source();
  let isMounted = true;

  (async () => {
    try {
      const options = {
        method: "get",
        url: "template/view",
        auth: true,
        data: null,
        token: { cancelToken: controller.token },
      };

      const getTemplates = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data,
        options.token
      );

      if (isMounted && getTemplates.status === 200) {
        dispatch(setTemplate(getTemplates.data));
      }
    } catch (err) {
      if (!axios.isCancel(err) && isMounted) {
        console.log(err);
        dispatch(
          showSnackbar({
            message: "Error fetching templates",
            severity: "error",
          })
        );
      }
    }
  })();

  return () => {
    isMounted = false;
    controller.cancel("Component unmounted");
  };
}, [dispatch]);



  const templateFunction = async()=>{
    const options = {
      method: "get",
      url: "template/view",
      auth: true,
      data: null,
    };

    const getTemplates = await Axios(
      options.method,
      options.url,
      options.auth,
      options.data
    );

    if(getTemplates.status === 200){
      dispatch(setTemplate(getTemplates.data));
      // window.location.reload();
      setEditable(false)
    }
  }
  
  async function setMessageTemplate(){

    if(templateType === "mail" && (subject === "" || header === "" || message === "" || footer === "")){
      return dispatch(showSnackbar({
        severity: "error",
        message: "There are one or more input fields empty, Please enter valid information"
      }))
    }

    if(templateType === "whatsapp" && message === ""){
      return dispatch(showSnackbar({
        severity: "error",
        message: "There are one or more input fields empty, Please enter valid information"
      }))
    }

    if(error.subjectError || error.headerError || error.footerError){
      return dispatch(showSnackbar({
        severity: "error",
        message: "There are errors in your input fields, Please enter valid information"
      }))
    }

    try{
      setLoading(true)
      const response = await Axios("put", "template/update", true, {
        template_type: templateType,
        mail_type: templateType === "mail" ? mailType : whatsappType,
        subject: templateType === "mail" ? subject : null,
        header: templateType === "mail" ? header : null,
        message: templateType === "mail" ? message : whatsappMessage,
        footer: templateType === "mail" ? footer : null,
        temp_created_by: userId
      })

      if(response.status === 200){
        setLoading(false)
        dispatch(showSnackbar({
          severity: "success",
          message: "Template updated successfully"
        }));
        templateFunction()
        
      }

    }catch(err){
      setLoading(false)
      dispatch(showSnackbar({
        severity: "error",
        message: "An error occured, unable to update template"
      }));
    }
  }

  const cancelField = () => {
    // templateFunction()
    setResetField(true)
    setEditable(false)
  }

  const handleSwitchChange = () => {
    setResetField(false);
    setEditable((prev) => !prev);
  };

  useEffect(() => {
    if(mailType === "batch_creation_mail_template"){
      setEditable(false)
    }
  }, [ mailType ])
  return (
    <Box sx={{height: "auto", width: "600px", mx: "auto", display: "flex", flexDirection: "column", gap: "25px"}}>
      {/* Title */}
      <Box
        sx={{
          mt: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box>
          <Typography variant="h5" component="div">
            Configure templates
          </Typography>
        </Box>
      </Box>

      {/* Input Fields */}

      <Stack direction="row" justifyContent="space-between">
        <FormControl>
          <Typography>Category :</Typography>
          <RadioGroup
              value={templateType}
              onChange={(e) => setTemplateType(e.target.value)}
              sx={{display: "inline"}}
          >
              <FormControlLabel value="mail" control={<Radio />} label="Mail" />
              <FormControlLabel value="whatsapp" control={<Radio />} label="Whatsapp" />
          </RadioGroup>
        </FormControl>

        {mailType !== "batch_creation_mail_template" &&
          <FormControlLabel
            value={editable}
            // onChange={() =>{ 
            //   setResetField(false);
            //   setEditable(!editable)}}
            control={<Switch 
              checked={editable}   // Bind switch to editable state
              onChange={handleSwitchChange}
              color="primary" />}
            label="Edit"
            labelPlacement="end"
          />
        }
      </Stack>

      {templateType === "mail" &&
        <>
        <TextField
          select
          fullWidth
          size="small"
          variant="outlined"
          label="Select mail template"
          value={mailType}
          onChange={(e) => setMailType(e.target.value)}
        
        >
          {/* <MenuItem value="teacher_callout_mail_template">Teacher callout mail</MenuItem>
          <MenuItem value="student_callout_mail_template">Student callout mail</MenuItem>
          <MenuItem value="teacher_creation_mail_template">Teacher creation mail</MenuItem>
          <MenuItem value="batch_creation_mail_template">Batch creation mail</MenuItem>
          <MenuItem value="forgot_password_mail_template">Forgot password mail</MenuItem> */}
          {selectMailTemplateDropdownArray.map((element, index) => {

            let letter = element.mail_type.split("_").splice(0, element.mail_type.split("_").length - 1).join(" ");
            let firstLetter = letter.charAt(0).toUpperCase();
            let remainingLetters = letter.slice(1)
            return <MenuItem key={index} value={element.mail_type}>{firstLetter + remainingLetters}</MenuItem>
          })}
        </TextField>

      <TextField
        // sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }}}
        fullWidth
        label='Subject'
        variant='outlined'
        size='small' 
        color='primary'
        value={subject}
        disabled={!editable}
        onChange={(e) => {
          if(e.target.value.length > 50){
            setError(prev => ({...prev, subjectError: true}))
            setSubject(e.target.value)
          }else{
            setError(prev => ({...prev, subjectError: false}))
            setSubject(e.target.value)
          }
        }}
        error={error.subjectError} 
        helperText={error.subjectError && "Subject should not exceed more than 10 characters"}
      />

      <TextField
        // sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }}}
        fullWidth
        label='header'
        variant='outlined'
        size='small' 
        color='primary'
        disabled={!editable}
        value={header}
        onChange={(e) => {
          if(e.target.value.length > 50){
            setError(prev => ({...prev, headerError: true}))
            setHeader(e.target.value)
          }else{
            setError(prev => ({...prev, headerError: false}))
            setHeader(e.target.value)
          }
          
        }} 
        error={error.headerError} 
        helperText={error.headerError && "Header should not exceed more than 10 characters"}
      />
    
      <TextField
        // sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }}}
        fullWidth
        label='Type message here'
        variant='outlined'
        size='small' 
        color='primary' 
        multiline
        disabled={!editable}
        rows={5}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />

      <TextField
        // sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }}}
        fullWidth
        label='footer'
        variant='outlined'
        size='small' 
        color='primary'
        multiline
        rows={3}
        disabled={!editable}
        value={footer}
        onChange={(e) => {
          if(e.target.value.length > 50){
            setError(prev => ({...prev, footerError: true}))
            setFooter(e.target.value)
          }else{
            setError(prev => ({...prev, footerError: false}))
            setFooter(e.target.value)
          }
        }} 
        error={error.footerError} 
        helperText={error.footerError && "Footer should not exceed more than 10 characters"}
        
      />

      {modifiedDetails.modifiedBy && modifiedDetails.modifiedAt &&
        <Stack direction="row" justifyContent="space-between">
          <Typography>Modified by: {modifiedDetails.modifiedBy}</Typography>
          <Typography>Modified at: {new Date(Date.parse(modifiedDetails.modifiedAt)).toLocaleString("en-IN", {
              timeZone: "Asia/Calcutta",
            })}</Typography>
        </Stack>}
      </>}

      {templateType === "whatsapp" && 
        <>
        <TextField
          select
          fullWidth
          size="small"
          variant="outlined"
          label="Select whatsapp template"
          value={whatsappType}
          onChange={(e) => setWhatsappType(e.target.value)}
          defaultValue={"teacher_callout_whatsapp_template"}
        >
          {selectWhatsappTemplateDropdownArray.map((element, index) => {
            let letter = element.mail_type.split("_").splice(0, element.mail_type.split("_").length - 1).join(" ");
            let firstLetter = letter.charAt(0).toUpperCase();
            let remainingLetters = letter.slice(1)
            return <MenuItem key={index} value={element.mail_type}>{firstLetter + remainingLetters}</MenuItem>
          })}
        </TextField>

        <TextField
          // sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }}}
          fullWidth
          label='Type message here'
          variant='outlined'
          size='small' 
          color='primary' 
          multiline
          disabled={!editable}
          value={whatsappMessage}
          onChange={(e) => setWhatsappMessage(e.target.value)}
          rows={5}
        />

        {modifiedDetails.modifiedBy && modifiedDetails.modifiedAt && 
          <Stack direction="row" justifyContent="space-between">
            <Typography>Modified by: {modifiedDetails.modifiedBy}</Typography>
            <Typography>Modified at: {new Date(Date.parse(modifiedDetails.modifiedAt)).toLocaleString("en-IN", {
                timeZone: "Asia/Calcutta",
              })}</Typography>
          </Stack>}
        </>}

      {/* Buttons */}
      <Box
        sx={{
          mt: "16px",
          mb: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          type="button"
          variant="contained"
          color="inherit"
          sx={{ mr: "16px" }}
          onClick={() =>cancelField()}
        >
          cancel
        </Button>
        <LoadingButton
          type="submit"
          variant="contained"
          color="primary"
          loading={isLoading}
          onClick={setMessageTemplate}
        >
          submit
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default SetMessageTemplates